import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import * as fromSeriousSystem from '@serious-system';

@Component({
  selector: 'squadbox-not-found',
  imports: [RouterModule, TranslateModule, fromSeriousSystem.ButtonDirective],
  template: `
    <div class="flex items-center justify-center h-screen">
      <div class="text-center">
        <h1 class="typo-display1 text-neutral-300">
          {{ 'PAGE_NOT_FOUND.TITLE' | translate }}
        </h1>
        <p class="mb-1">
          {{ 'PAGE_NOT_FOUND.DESCRIPTION' | translate }}
        </p>
        <a sdButton variant="tonal" color="neutral" routerLink="/">
          {{ 'PAGE_NOT_FOUND.CTA_BACK_HOME' | translate }}
        </a>
      </div>
    </div>
  `,
  styles: [``],
})
export class NotFoundPage {}
